module.exports = __webpack_public_path__ + "static_pest_wiki_details/img/paidui_type03.e6814ec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pc/product_info/paidui_type03.jpg
// module id = iMNb
// module chunks = 0